import PropTypes from "prop-types"

export const API_CONSTRAINTS = PropTypes.shape({
  maxTurnover: PropTypes.number.isRequired,
  maxLiquidationDays: PropTypes.number,
})
